import { Box } from "../../../../mads";

import { Image, StyleSheet } from "react-native";

export const BANNER_IMAGE_HEIGHT = 100;

// url1960x400 header asset aspect ratio.
const BANNER_IMAGE_ASPECT_RATIO = 1960 / 400;

interface CompanyBannerImageProps {
  url: string;
  companyLogo?: React.ReactNode;
  /**
   * Size the banner to the fixed 1960:400 header ratio (height derived from width)
   * instead of the fixed 100px height. Height stays bounded by the container width
   * (height = width / 4.9) regardless of the source image's dimensions; `cover` crops
   * the source into that box. Avoids the aggressive cropping the fixed height causes on
   * narrow surfaces.
   */
  preserveAspectRatio?: boolean;
}

export function CompanyBannerImage({
  url,
  companyLogo,
  preserveAspectRatio = false,
}: CompanyBannerImageProps) {
  return (
    <Box sx={styles.container}>
      <Image
        source={{ uri: url }}
        style={[styles.bannerImage, preserveAspectRatio && styles.bannerImageAspectRatio]}
        accessibilityRole="image"
        accessibilityLabel="Company banner"
        resizeMode="cover"
      />
      {companyLogo && <Box sx={styles.logoOverlay}>{companyLogo}</Box>}
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    padding: 4,
    marginTop: -16,
    marginStart: -16,
    marginEnd: -16,
    marginBottom: 8,
  },
  bannerImage: {
    width: "100%",
    height: BANNER_IMAGE_HEIGHT,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 2,
  },
  bannerImageAspectRatio: {
    height: undefined,
    aspectRatio: BANNER_IMAGE_ASPECT_RATIO,
  },
  logoOverlay: {
    position: "absolute",
    bottom: -8,
    left: 12,
  },
});
